import React, { useState, useEffect } from 'react';

const Youtube: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(false);
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="youtube-player">
      {showBanner && (
        <div className="welcome-banner">
          <svg className="curved-arrow" width="50" height="50" viewBox="0 0 50 50">
  <path
    d="M10 25 Q 25 10, 40 25 T 70 25"
    fill="#000"
    stroke="#ff0000"
    strokeWidth="2"
    className="arrow-path"
  />
  <path
    d="M35 25 L 40 20 L 45 25"
    fill="#000"
    stroke="#ff0000"
    strokeWidth="2"
    className="arrow-head"
  />
</svg>

          <span className="banner-text">
            Welcome! Relax, I need Approx 3mins from you, Click PLAY, Enjoy, and Read about me, Thanks For your Time
          </span>
        </div>
      )}
      <button 
        className="youtube-close-btn"
        onClick={() => setIsVisible(false)}
      >
        ×
      </button>
      <iframe 
        height="115" 
        src="https://www.youtube.com/embed/qdJBs5ENgjE?si=ehbuo7lNoKCusZdI&autoplay=1" 
        title="YouTube video player" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
};

export default Youtube;
